// extracted by mini-css-extract-plugin
export default {"fullWidthRow":"styles_fullWidthRow__x6KwO","labelRow":"styles_labelRow__EtSRO","checkboxContainer":"styles_checkboxContainer__jd2He","checkmark":"styles_checkmark__L+gfG"};